import { render } from "./Home.vue?vue&type=template&id=3d846e12&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./custom-home.scss?vue&type=style&index=0&id=3d846e12&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=3d846e12&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d846e12"]])

export default __exports__